/* 🤖 this file was generated by svg-to-ts */
export const siriusThermometerSimple: {
  name: 'thermometer_simple';
  data: string;
} = {
  name: 'thermometer_simple',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 15.109a2.626 2.626 0 1 0 1.5 0V8.25a.75.75 0 0 0-1.5 0v6.859ZM12 16.5a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.348 1.848A3.75 3.75 0 0 1 15.75 4.5v8.931a5.625 5.625 0 1 1-7.5 0V4.5a3.75 3.75 0 0 1 1.098-2.652ZM12 2.25A2.25 2.25 0 0 0 9.75 4.5v9.281a.75.75 0 0 1-.288.591 4.125 4.125 0 1 0 5.077 0 .75.75 0 0 1-.289-.59V4.5A2.25 2.25 0 0 0 12 2.25Z" fill="currentColor"/></svg>`
};
